import { TrendingUp } from "lucide-react";

// Recreated brand mark: blue tile with upward-trend arrow + "Elevate FINANCIAL" wordmark.
// variant "light" => white "Elevate" (for dark backgrounds); "dark" => navy "Elevate".
export const BrandLogo = ({ variant = "light", size = "md", testId = "brand-logo" }) => {
  const dims = {
    sm: { tile: "h-9 w-9", icon: 18, elevate: "text-2xl", fin: "text-[9px]", rad: "rounded-lg" },
    md: { tile: "h-12 w-12", icon: 24, elevate: "text-3xl sm:text-4xl", fin: "text-[11px]", rad: "rounded-xl" },
    lg: { tile: "h-16 w-16", icon: 32, elevate: "text-4xl sm:text-5xl", fin: "text-[13px]", rad: "rounded-2xl" },
  }[size];

  const elevateColor = variant === "light" ? "text-white" : "text-[#0f1a2e]";

  return (
    <div className="flex items-center gap-3" data-testid={testId}>
      <div
        className={`${dims.tile} ${dims.rad} flex items-center justify-center shadow-lg shrink-0`}
        style={{ background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)" }}
      >
        <TrendingUp size={dims.icon} strokeWidth={2.75} className="text-white" />
      </div>
      <div className="flex flex-col leading-none">
        <span className={`font-serif-brand font-bold ${dims.elevate} ${elevateColor} tracking-tight`}>
          Elevate
        </span>
        <span
          className={`${dims.fin} font-semibold tracking-[0.35em] mt-1`}
          style={{ color: "var(--efl-gold)" }}
        >
          FINANCIAL
        </span>
      </div>
    </div>
  );
};
